import { FormGroup } from '@angular/forms';

export const trimFgEmptyControls = <T = Object>(fg: FormGroup): T => {
  return Object.fromEntries(Object.entries(fg.getRawValue()).filter(([_, v]) => v != null && v !== '')) as unknown as T;
};
